<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">リセット</span>
        </div>
        <div class="popup-content">
          <form @submit.prevent>
          　<p class="txt reset-txt">アカウントをリセットします。<br>アカウントに紐づく以下のデータが消えてしまいますがよろしいですか？</p>
            <ul class="list-dot mt32">
              <li>このアカウントで作成・共有されたノート</li>
              <li>後で見る、ブックマーク、保存検索条件</li>
              <li>閲覧履歴、検索履歴</li>
              <li>付与されているライセンス</li>
              <li>ダッシュボードのカスタマイズ設定</li>
              <li>アップデート通知の設定機能</li>
            </ul>
            <div class="button mt32">
              <button class="btn" @click="submit">リセット</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAccountReset } from '@/logic/contract/ContractAccountReset'

export default defineComponent({
  name: 'PCContractAccountReset',
  setup (props, context) {
    return { ...ContractAccountReset(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.reset-txt {
  font-size: 1.6rem;
}
.list-dot {
  color: $color-content;
  list-style: none;
  li {
    text-indent: -1em;
    padding: 5px 0 5px 1em;
    font-size: 1.6rem;
    &::before {
      content: "・";
    }
  }
}
.popup-content .button {
  width: 230px;
  margin-right: auto;
  margin-left: auto;
}
</style>
